"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promptDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const context_1 = require("../resources/context");
const planUlid_1 = require("../tools/planUlid");
exports.promptDef = {
    name: 'do-next-step',
    description: 'Load plan and thread context, return an instruction to implement the next incomplete step.',
    arguments: [
        { name: 'planUlid', description: 'Plan ULID (e.g. "pl_01J…").', required: true },
    ],
};
async function handle(root, args) {
    const planUlid = args['planUlid'];
    if (!planUlid)
        throw new Error('planUlid is required');
    // Strict, ULID-only — matches the plan-step tools' requirePlanUlid contract.
    // A filename stem or title is rejected here; the CLI resolves any friendly
    // reference to a pl_ ULID at its own edge (see next.ts resolvePlanUlid) before
    // calling this prompt.
    if (!(0, planUlid_1.isPlanUlid)(planUlid)) {
        throw new Error(`planUlid must be a plan's stable pl_ ULID (e.g. "pl_01J…"), not a filename stem or title. Got: ${JSON.stringify(planUlid)}.`);
    }
    // ULID → file path.
    const { filePath } = await (0, dist_1.resolveDocIdOrThrow)(root, planUlid);
    const plan = await (0, dist_1.loadDoc)(filePath);
    if (plan.type !== 'plan')
        throw new Error(`Document ${planUlid} is not a plan`);
    // Find first incomplete step
    const steps = plan.steps ?? [];
    const nextStep = steps.find(s => s.status !== 'done' && s.status !== 'cancelled');
    const messages = [];
    // Unified context pipeline: bundles global/weave/thread ctx + the plan's
    // parent chain + the plan itself (as target) + requires_load. Replaces the
    // old ad-hoc thread-context + separate plan-content push.
    try {
        const ctx = await (0, context_1.handleContextResource)(root, `loom://context/${planUlid}?mode=implementing`);
        messages.push({ role: 'user', content: { type: 'text', text: ctx.contents[0].text } });
    }
    catch { /* context is best-effort */ }
    const instruction = nextStep
        ? [
            `Implement step ${nextStep.order ?? '?'}${nextStep.id ? ` (id: ${nextStep.id})` : ''}: ${nextStep.description}`,
            '',
            `After completing this step, call loom_complete_step with plan_ulid="${planUlid}" and stepNumber=${nextStep.order}.`,
        ].join('\n')
        : `All steps are complete in plan ${planUlid}. You may close it using loom_close_plan.`;
    messages.push({ role: 'user', content: { type: 'text', text: instruction } });
    return {
        description: nextStep
            ? `Implement step ${nextStep.order} of ${planUlid}: ${nextStep.description}`
            : `All steps complete in ${planUlid}`,
        messages,
    };
}
